import { z } from "zod";
import {
  HttpMethodSchema,
  JsonSchemaFragmentSchema,
  ParamLocationSchema
} from "./primitives.js";

export const ParameterSchema = z.object({
  name: z.string().min(1),
  location: ParamLocationSchema,
  required: z.boolean(),
  schema: JsonSchemaFragmentSchema,
  description: z.string().optional()
});
export type Parameter = z.infer<typeof ParameterSchema>;

export const RequestBodySchema = z.object({
  contentType: z.string().min(1).default("application/json"),
  required: z.boolean(),
  schema: JsonSchemaFragmentSchema
});
export type RequestBody = z.infer<typeof RequestBodySchema>;

export const ResponseSchema = z.object({
  status: z.string().regex(/^\d{3}$|^default$/),
  description: z.string().optional(),
  schema: JsonSchemaFragmentSchema.optional()
});
export type Response = z.infer<typeof ResponseSchema>;

export const OperationSchema = z.object({
  id: z.string().min(1),
  method: HttpMethodSchema,
  path: z.string().startsWith("/"),
  summary: z.string().optional(),
  description: z.string().optional(),
  parameters: z.array(ParameterSchema),
  requestBody: RequestBodySchema.optional(),
  responses: z.array(ResponseSchema),
  tags: z.array(z.string()).default([]),
  security: z.array(z.record(z.array(z.string()))).default([])
});
export type Operation = z.infer<typeof OperationSchema>;

export const CapabilityModelSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  apiTitle: z.string(),
  apiVersion: z.string(),
  baseUrl: z.string().url().optional(),
  operations: z.array(OperationSchema),
  tags: z.array(z.object({ name: z.string(), description: z.string().optional() })).default([])
});
export type CapabilityModel = z.infer<typeof CapabilityModelSchema>;
